import React, {
  createContext, useCallback, useContext, useMemo,
} from 'react';

import { getCountryDisplayName } from '../../../../../../utils/country';

import type { IValueChainLocationsContext } from '../interfaces/IValueChainLocationsContext';
import type { IValueChainLocationsProvider } from '../interfaces/IValueChainLocationsProvider';

const ValueChainLocationsContext = createContext<IValueChainLocationsContext | undefined>(undefined);

export const useValueChainLocations = (): IValueChainLocationsContext => {
  const context = useContext(ValueChainLocationsContext);

  if (!context) {
    throw new Error('useValueChainLocations must be used within ValueChainLocationsProvider');
  }

  return context;
};

function ValueChainLocationsProvider({ countryLookup, children }: IValueChainLocationsProvider) {
  const getCountryName = useCallback((countryCode: string) => (
    getCountryDisplayName(countryCode, countryLookup) || countryCode
  ), [countryLookup]);

  const contextValue = useMemo((): IValueChainLocationsContext => ({
    countryLookup,
    getCountryName,
  }), [countryLookup, getCountryName]);

  return (
    <ValueChainLocationsContext.Provider value={contextValue}>
      {children}
    </ValueChainLocationsContext.Provider>
  );
}

export default ValueChainLocationsProvider;
